<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker
                                    v-model="inputDate" 
                                    :format="dateFormat" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <base-input alternative="" label="From Time"><br>
                                <a-time-picker use12Hours v-model="inputTimeFrom" format="h A" style="width: 100%" />
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <base-input alternative="" label="To"><br>
                                <a-time-picker use12Hours v-model="inputTimeTo" format="h A" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-radio name="S" class="mb-3" v-model="inputDisplay">
                                Summary Only
                            </base-radio>
                            <base-radio name="I" class="mb-3" v-model="inputDisplay">
                                Items sold per hour
                            </base-radio>
                        </div>
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isFilterTerminal">
                                Filter by Terminal
                            </base-checkbox>
                            <a-select v-if="isFilterTerminal == true" v-model="inputTerminal" showSearch placeholder="Enter Terminal" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div v-if="inputDisplay == 'I'" class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div v-if="inputGroupBy != 'hourly'" class="col-md-4">
                            <br>
                            <base-checkbox class="mb-3 pt-1" v-model="isShowDetail">
                                Show Details
                            </base-checkbox>
                        </div>
                    </div>
                    <div v-if="inputDisplay == 'I'" class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>                          
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="filterVisible">
                <advance-filter :parentParams="filterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment(), moment()],
                inputTimeFrom: moment('8 AM', 'h A'),
                inputTimeTo: moment('7 PM', 'h A'),
                inputDisplay: 'S',
                inputGroupBy: 'hourly',
                isShowDetail: true,
                groupOptions: [
                    {key: 'hourly', value: 'Hourly Sales'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'},
                    {key: 'supplier_id', value: 'Supplier'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                isFilterTerminal: false,
                inputTerminal: null,
                terminalOptions: [],
                dateFormat: 'MM/DD/YYYY',
                datePickerPlaceholder: ['Start', 'End'],
                birSalesReports: [],

                toggleAdvanceFilter: false, 
                toggleLabel: "Advanced Filter",
                filterParams: {},
                params: {},
                filterVisible: true,
                JsonData: [],
                terminal_name: 'All Terminals',
            }
        },
        watch: {
            inputSite(newSiteIds) {
                this.updateTerminaOptions(newSiteIds)
            },
            inputTerminal(id){
                const terminal = this.terminalOptions.find(t => t.id === id);
                if (terminal) {
                    this.terminal_name = terminal.name;
                } else {
                    this.terminal_name = this.terminal_name; // All Terminals ?? jirah
                }
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }

            // var terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals", null);
            // component_x.terminalOptions = terminals;
            // component_x.sort(component_x.terminalOptions);

            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions = this.terminalOptions.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }
        },
        computed: {
            ...mapState(['endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.filterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            async updateTerminaOptions(siteId){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
                this.terminalOptions = terminals;
                    this.terminalOptions = this.terminalOptions.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.isFilterTerminal == false){
                    this.inputTerminal = null;
                }

                var filter_header = ''
                var additional_params = ''

                var status_header = "([Active],[Inactive],[Phase-out])"
                if(this.params.status != undefined && this.params.status.length != 0){
                    var statuses = this.params.status
                    for (let s = 0; s < statuses.length; s++) {
                        const element = statuses[s];
                        let text;
                         switch(element) {
                            case 'A':
                                text = 'Active';
                            break;
                            case 'I':
                                text = 'Inactive';
                            break;
                            case 'P':
                                text = 'Phase-out';
                            break;
                        }
                        if(s == 0){
                            status_header = "("
                            status_header += `[${text}]`
                        } else {
                            status_header += `,[${text}]`
                            if (s == statuses.length-1){
                                status_header = ")"
                            }
                        }
                    } 
                    additional_params += '&status=' + this.params.status
                }

                if(this.params.design_id != undefined && this.params.design_id != null && this.params.design_id.length != 0){
                    additional_params += '&design_id=' + this.params.design_id
                    filter_header += ` with Design (${this.filterParams.design_name})`
                }

                if(this.params.color_id != undefined && this.params.color_id != null && this.params.color_id.length != 0){
                    additional_params += '&color_id=' + this.params.color_id
                    filter_header += ` with Color (${this.filterParams.color_name})`
                }

                if(this.params.size_id != undefined && this.params.size_id != null && this.params.size_id.length != 0){
                    additional_params += '&size_id=' + this.params.size_id
                    filter_header += ` with Size (${this.filterParams.size_name})`
                }

                if(this.params.product_line_id != undefined && this.params.product_line_id != null && this.params.product_line_id.length != 0){
                    additional_params += '&product_line_id=' + this.params.product_line_id
                    filter_header += ` with Product Line (${this.filterParams.product_line_name})`
                }

                if(this.params.product_type != undefined && this.params.product_type != null && this.params.product_type.length != 0){
                    additional_params += '&product_type=' + this.params.product_type
                    filter_header += ` with Product Type (${this.filterParams.product_type_name})`
                }

                if(this.params.supplier_type_id != undefined && this.params.supplier_type_id != null && this.params.supplier_type_id.length != 0){
                    additional_params += '&supplier_type_id=' + this.params.supplier_type_id
                    filter_header += ` with Supplier Type (${this.filterParams.supplier_type_name})`
                }

                if(this.params.tax_type != undefined && this.params.tax_type != null && this.params.tax_type.length != 0){
                    additional_params += '&tax_type=' + this.params.tax_type
                    filter_header += ` with Tax Type (${this.filterParams.tax_type_name})`
                }

                if(this.params.barcode != undefined && this.params.barcode != null && this.params.barcode != ''){
                    additional_params += '&barcode=' + this.params.barcode
                    filter_header += ` with Barcode (${this.params.barcode})`
                }

                if(this.params.stock_no != undefined && this.params.stock_no != null && this.params.stock_no != ''){
                    additional_params += '&stock_no=' + this.params.stock_no
                    filter_header += ` with Stock No. (${this.params.stock_no})`
                }

                if(this.params.name != undefined && this.params.name != null && this.params.name != ''){
                    additional_params += '&name=' + this.params.name
                    filter_header += ` with Name (${this.params.name})`
                }

                if(this.params.retail_price != undefined && this.params.retail_price != null && this.params.retail_price != ''){
                    additional_params += '&retail_price=' + this.params.retail_price
                    filter_header += ` with Retail Price (${this.params.retail_price})`
                }

                if(this.params.category_id != undefined && this.params.category_id.length != 0){
                    additional_params += '&category_id=' + this.params.category_id
                    if(this.params.category_name != undefined){
                        filter_header += ` with Category (${this.filterParams.category_name})`
                    }
                }

                if(this.params.division_id != undefined && this.params.division_id.length != 0){
                    additional_params += '&division_id=' + this.params.division_id
                    if(this.params.division_name != undefined){
                        filter_header += ` with Division (${this.filterParams.division_name})`
                    }
                }

                if(this.params.department_id != undefined && this.params.department_id.length != 0){
                    additional_params += '&department_id=' + this.params.department_id
                    if(this.params.department_name != undefined){
                        filter_header += ` with Department (${this.filterParams.department_name})`
                    }
                }

                if(this.params.section_id != undefined && this.params.section_id.length != 0){
                    additional_params += '&section_id=' + this.params.section_id
                    if(this.params.section_name != undefined){
                        filter_header += ` with Section (${this.filterParams.section_name})`
                    }
                }

                if(this.params.supplier_id != undefined && this.params.supplier_id.length != 0){
                    additional_params += '&supplier_id=' + this.params.supplier_id
                    filter_header += ` with Supplier (${this.filterParams.supplier_name})`
                }

                if(this.params.brand_id != undefined && this.params.brand_id.length != 0){
                    additional_params += '&brand_id=' + this.params.brand_id
                    filter_header += ` with Brand (${this.filterParams.brand_name})`
                }

                if(this.inputGroupBy == 'hourly'){
                    this.isShowDetail = true
                }

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                if(this.inputTimeFrom == null || this.inputTimeTo == null){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/hourly_sales?site_id=' + this.inputSite + 
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD') + 
                    '&time_from=' + this.inputTimeFrom.format('HH:mm') + '&isShow=' + this.isShowDetail + '&time_to=' + this.inputTimeTo.format('HH:mm') + '&group=' + 
                    this.inputGroupBy + '&display=' + this.inputDisplay + '&terminal=' + this.inputTerminal + additional_params, null);
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
                var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                let reportLogo = document.getElementById('reportLogo');
                doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                if(this.inputDisplay == 'S'){
                    let headers = [
                        [
                            {content: 'Sale Hours', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                            {content: 'Sales Amount', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                            {content: 'Qty Sold', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                            {content: 'Qty Returned', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                            {content: 'No. of Transaction(s)', colSpan: 2, styles: {halign: 'center', valign: 'center'}}
                        ],
                        [
                            {content: 'SALES', styles: {halign: 'center', valign: 'center'}},
                            {content: 'RETURN', styles: {halign: 'center', valign: 'center'}},
                        ]
                    ];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        var total_amount_gross = 0
                        var total_quantity = 0
                        var total_return_quantity = 0
                        var total_sales_count = 0
                        var total_return_count = 0

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                reportLine.forEach(element => {
                                    let detail = [
                                        element.sale_hours,
                                        this.convertToCurrency(Number(element.amount_gross)),
                                        this.convertToCurrency(Number(element.total_quantity)),
                                        this.convertToCurrency(Number(element.return_quantity)),
                                        this.formatNumber(Number(element.sales_count)),
                                        this.formatNumber(Number(element.return_count))
                                    ]

                                    total_amount_gross += Number(element.amount_gross)
                                    total_quantity += Number(element.total_quantity)
                                    total_return_quantity += Number(element.return_quantity)
                                    total_sales_count += Number(element.sales_count)
                                    total_return_count += Number(element.return_count)

                                    reportData.push(Object.assign({}, detail))
                                });

                                if(i == this.birSalesReports.length-1){
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['Grand Total :', 
                                        this.convertToCurrency(Number(total_amount_gross)),
                                        this.convertToCurrency(Number(total_quantity)),
                                        this.convertToCurrency(Number(total_return_quantity)),
                                        this.formatNumber(Number(total_sales_count)),
                                        this.formatNumber(Number(total_return_count))
                                    ]));
                                }
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Hourly Sales [Net of Returns] Report")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // doc.text(300,20,siteSpecific[x].report_details[0][0].site_name);
                        doc.text(15,25,"For the Period of " + this.inputDate[0].format('MMMM DD, YYYY')  + " to " + this.inputDate[1].format('MMMM DD, YYYY'))
                        doc.text(15,30,"Site: " + siteSpecific[x].report_details[0][0].site_name);
                        doc.text(15,35,"Terminal: " + this.terminal_name);

                        doc.autoTable({
                            startY: 40, 
                            head: headers, 
                            body: reportData, 
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: {
                                0: {cellWidth: 50},
                                1: {cellWidth: 70},
                                2: {cellWidth: 50},
                                3: {cellWidth: 50},
                                4: {cellWidth: 50},
                                5: {cellWidth: 50}
                            },
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                        // doc.text(15,200,"Printed By: " + secureStorage.getItem("email"))
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report", "right")

                        // doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                        // doc.text(340,205,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")

                    }
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                            printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    let design_x = 340
                    let design_y =  205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Hourly Sales (Net of Returns) Report", design_x, design_y, i, pageCount)
                    }
                } else {
                    let headers = []
                    if(this.inputGroupBy == 'hourly'){
                        headers = [
                            [
                                {content: 'Product Code', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Qty Sold', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Qty Ret', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Amount Sold', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ];
                    } else {
                        if(this.isShowDetail == false){
                            headers = [
                                [
                                    {content: '', styles: {halign: 'center', valign: 'center'}},
                                    {content: '', styles: {halign: 'center', valign: 'center'}},
                                    {content: '', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Sales', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Return', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Qty Sold', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Qty Ret', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Amount Sold', styles: {halign: 'center', valign: 'center'}}
                                ]
                            ];
                        } else {
                            headers = [
                                [
                                    {content: 'Product Code', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Sales', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Return', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Qty Sold', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Qty Ret', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Amount Sold', styles: {halign: 'center', valign: 'center'}}
                                ]
                            ];
                        }
                        
                    }
                    
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        var g_total_quantity = 0
                        var g_total_return_quantity = 0
                        var g_total_subtotal = 0

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                var h_total_quantity = 0
                                var h_total_return_quantity = 0
                                var h_total_subtotal = 0

                                var s_total_quantity = 0
                                var s_total_return_quantity = 0
                                var s_total_subtotal = 0

                                if(this.inputGroupBy != 'hourly'){
                                    var h_total_sales = 0
                                    var h_total_return = 0

                                    var s_total_sales = 0
                                    var s_total_return = 0
                                }

                                let grouper_name = ''
                                for(var y=0; y < reportLine.length; y++){
                                    var element = reportLine[y];

                                    if(y == 0){
                                        let detail = [element.sale_hours]
                                        reportData.push(Object.assign({}, detail))
                                    }

                                    if(element.product_code != ''){
                                        if(this.inputGroupBy == 'hourly'){
                                            let detail = [
                                                '        ' + element.product_code,
                                                element.barcode,
                                                element.product_name,
                                                this.convertToCurrency(Number(element.quantity)),
                                                this.convertToCurrency(Number(element.return_quantity)),
                                                this.convertToCurrency(Number(element.subtotal))
                                            ]

                                            reportData.push(Object.assign({}, detail))
                                        } else {
                                            if (this.isShowDetail == true){
                                                if(grouper_name == ''){
                                                    let detail_header = [element.grouper_name]
                                                    reportData.push(Object.assign({}, detail_header))
                                                } else {
                                                    if(grouper_name != element.grouper_name){
                                                        let detail_header = [element.grouper_name];
                                                        reportData.push(Object.assign({}, detail_header))
                                                    }
                                                }
                                            }

                                            let detail
                                            if(this.isShowDetail == true){
                                                detail = [
                                                    '        ' + element.product_code,
                                                    element.barcode,
                                                    element.product_name,
                                                    this.formatNumber(Number(element.sales_count)),
                                                    this.formatNumber(Number(element.return_count)),
                                                    this.convertToCurrency(Number(element.quantity)),
                                                    this.convertToCurrency(Number(element.return_quantity)),
                                                    this.convertToCurrency(Number(element.subtotal))
                                                ]
                                            } else {
                                                detail = [
                                                    '', '', element.grouper_name,
                                                    this.formatNumber(Number(element.sales_count)),
                                                    this.formatNumber(Number(element.return_count)),
                                                    this.convertToCurrency(Number(element.quantity)),
                                                    this.convertToCurrency(Number(element.return_quantity)),
                                                    this.convertToCurrency(Number(element.subtotal))
                                                ]
                                            }

                                            reportData.push(Object.assign({}, detail))

                                            grouper_name = element.grouper_name
                                        }
                                    
                                        s_total_quantity += Number(element.quantity)
                                        s_total_return_quantity += Number(element.return_quantity)
                                        s_total_subtotal += Number(element.subtotal)

                                        h_total_quantity += Number(element.quantity)
                                        h_total_return_quantity += Number(element.return_quantity)
                                        h_total_subtotal += Number(element.subtotal)

                                        g_total_quantity += Number(element.quantity)
                                        g_total_return_quantity += Number(element.return_quantity)
                                        g_total_subtotal += Number(element.subtotal)

                                        if(this.inputGroupBy != 'hourly'){
                                            s_total_sales += Number(element.sales_count)
                                            s_total_return += Number(element.return_count)

                                            h_total_sales += Number(element.sales_count)
                                            h_total_return += Number(element.return_count)

                                            if(this.isShowDetail == true){
                                                if(y == reportLine.length - 1){
                                                    reportData.push(Object.assign({}, ["rowLine"]))
                                                    reportData.push(Object.assign({}, [element.grouper_name, '', 'Total :',
                                                        this.formatNumber(Number(s_total_sales)), 
                                                        this.formatNumber(Number(s_total_return)), 
                                                        this.convertToCurrency(Number(s_total_quantity)),
                                                        this.convertToCurrency(Number(s_total_return_quantity)),
                                                        this.convertToCurrency(Number(s_total_subtotal))
                                                    ]));

                                                    s_total_sales = 0
                                                    s_total_return = 0
                                                    s_total_quantity = 0
                                                    s_total_return_quantity = 0
                                                    s_total_subtotal = 0
                                                } else {
                                                    let current_grouper = element.grouper_name
                                                    let next_grouper = reportLine[y+1].grouper_name

                                                    if(current_grouper != next_grouper){
                                                        reportData.push(Object.assign({}, ["rowLine"]))
                                                        reportData.push(Object.assign({}, [element.grouper_name, '', 'Total :',
                                                            this.formatNumber(Number(s_total_sales)), 
                                                            this.formatNumber(Number(s_total_return)), 
                                                            this.convertToCurrency(Number(s_total_quantity)),
                                                            this.convertToCurrency(Number(s_total_return_quantity)),
                                                            this.convertToCurrency(Number(s_total_subtotal))
                                                        ]));

                                                        s_total_sales = 0
                                                        s_total_return = 0
                                                        s_total_quantity = 0
                                                        s_total_return_quantity = 0
                                                        s_total_subtotal = 0
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                if(this.inputGroupBy == 'hourly'){
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', 'Hourly Total :',
                                        this.convertToCurrency(Number(h_total_quantity)),
                                        this.convertToCurrency(Number(h_total_return_quantity)),
                                        this.convertToCurrency(Number(h_total_subtotal))
                                    ]));
                                } else {
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', 'Hourly Total :',
                                        this.formatNumber(Number(h_total_sales)), 
                                        this.formatNumber(Number(h_total_return)), 
                                        this.convertToCurrency(Number(h_total_quantity)),
                                        this.convertToCurrency(Number(h_total_return_quantity)),
                                        this.convertToCurrency(Number(h_total_subtotal))
                                    ]));
                                }

                                if(i == this.birSalesReports.length-1){
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    if(this.inputGroupBy == 'hourly'){
                                        reportData.push(Object.assign({}, ['', '', 'Grand Total', 
                                            this.convertToCurrency(Number(g_total_quantity)),
                                            this.convertToCurrency(Number(g_total_return_quantity)),
                                            this.convertToCurrency(Number(g_total_subtotal))
                                        ]))    
                                    } else {
                                        reportData.push(Object.assign({}, ['', '', 'Grand Total', ' - ', ' - ',
                                            this.convertToCurrency(Number(g_total_quantity)),
                                            this.convertToCurrency(Number(g_total_return_quantity)),
                                            this.convertToCurrency(Number(g_total_subtotal))
                                        ]))
                                    }
                                }
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        if(this.inputGroupBy == 'hourly'){
                            doc.text(15,20,"Hourly Sales [Net of Returns] Report by Item")
                        } else if (this.inputGroupBy == 'category_id') {
                            doc.text(15,20,"Hourly Sales [Net of Returns] Report by Category")
                        } else if (this.inputGroupBy == 'division_id') {
                            doc.text(15,20,"Hourly Sales [Net of Returns] Report by Division")
                        } else if (this.inputGroupBy == 'department_id') {
                            doc.text(15,20,"Hourly Sales [Net of Returns] Report by Department")
                        } else if (this.inputGroupBy == 'section_id') {
                            doc.text(15,20,"Hourly Sales [Net of Returns] Report by Section")
                        } else if (this.inputGroupBy == 'supplier_id') {
                            doc.text(15,20,"Hourly Sales [Net of Returns] Report by Supplier")
                        }
                        
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // doc.text(300,20,siteSpecific[x].report_details[0][0].site_name);
                        doc.text(15,25,"For the Period of " + this.inputDate[0].format('MMMM DD, YYYY')  + " to " + this.inputDate[1].format('MMMM DD, YYYY'))
                        doc.text(15,35,"Site: " +siteSpecific[x].report_details[0][0].site_name);
                        doc.text(15,40,"Terminal: " + this.terminal_name);
                        doc.setFontSize(8);
                        let splitTitle = doc.splitTextToSize("Filtered by: " + status_header + filter_header, 180);
                        doc.text(15,30,splitTitle);

                        let colStyles = {}
                        if(this.inputGroupBy == 'hourly'){
                            colStyles = {
                                0: {cellWidth: 40, halign: 'left'},
                                1: {cellWidth: 40},
                                2: {cellWidth: 125, halign: 'left'},
                                3: {cellWidth: 40},
                                4: {cellWidth: 40},
                                5: {cellWidth: 40}
                            }
                        } else {
                            colStyles = {
                                0: {cellWidth: 30, halign: 'left'},
                                1: {cellWidth: 30},
                                2: {cellWidth: 115, halign: 'left'},
                                3: {cellWidth: 30},
                                4: {cellWidth: 30},
                                5: {cellWidth: 30},
                                6: {cellWidth: 30},
                                7: {cellWidth: 30}
                            }
                        }

                        doc.autoTable({
                            startY: 45, 
                            head: headers, 
                            body: reportData, 
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[2] == 'Total :' && data.row.raw[2] == 'Hourly Total :' && data.row.raw[2] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                        
                    }
                    let footer_text = '';
                    // doc.text(15,200,"Printed By: " + secureStorage.getItem("email"))
                    if(this.inputGroupBy == 'hourly'){
                        footer_text = "Hourly Sales (Net of Returns) Report by Item"
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report by Item", "right")
                    } else if (this.inputGroupBy == 'category_id') {
                        footer_text = "Hourly Sales (Net of Returns) Report by Category"
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report by Category", "right")
                    } else if (this.inputGroupBy == 'division_id') {
                        footer_text = "Hourly Sales (Net of Returns) Report by Division"
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report by Division", "right")
                    } else if (this.inputGroupBy == 'department_id') {
                        footer_text = "Hourly Sales (Net of Returns) Report by Department"
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report by Department", "right")
                    } else if (this.inputGroupBy == 'section_id') {
                        footer_text = "Hourly Sales (Net of Returns) Report by Section"
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report by Section", "right")
                    } else if (this.inputGroupBy == 'supplier_id') {
                        footer_text = "Hourly Sales (Net of Returns) Report by Supplier"
                        // doc.text(340,200,"Hourly Sales (Net of Returns) Report by Supplier", "right")
                    }
                    // doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                    
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 340
                    let footer_y = 205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, footer_text, footer_x, footer_y, i, pageCount)
                    }
                }

                window.open(URL.createObjectURL(doc.output("blob")))
                // doc.save(`Hourly_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning = false;
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                if(this.isFilterTerminal == false){
                    this.inputTerminal = null;
                }

                var filter_header = ''
                var additional_params = ''

                var status_header = "([Active],[Inactive],[Phase-out])"
                if(this.params.status != undefined && this.params.status.length != 0){
                    var statuses = this.params.status
                    for (let s = 0; s < statuses.length; s++) {
                        const element = statuses[s];
                        let text;
                         switch(element) {
                            case 'A':
                                text = 'Active';
                            break;
                            case 'I':
                                text = 'Inactive';
                            break;
                            case 'P':
                                text = 'Phase-out';
                            break;
                        }
                        if(s == 0){
                            status_header = "("
                            status_header += `[${text}]`
                        } else {
                            status_header += `,[${text}]`
                            if (s == statuses.length-1){
                                status_header = ")"
                            }
                        }
                    } 
                    additional_params += '&status=' + this.params.status
                }

                if(this.params.design_id != undefined && this.params.design_id != null && this.params.design_id.length != 0){
                    additional_params += '&design_id=' + this.params.design_id
                    filter_header += ` with Design (${this.filterParams.design_name})`
                }

                if(this.params.color_id != undefined && this.params.color_id != null && this.params.color_id.length != 0){
                    additional_params += '&color_id=' + this.params.color_id
                    filter_header += ` with Color (${this.filterParams.color_name})`
                }

                if(this.params.size_id != undefined && this.params.size_id != null && this.params.size_id.length != 0){
                    additional_params += '&size_id=' + this.params.size_id
                    filter_header += ` with Size (${this.filterParams.size_name})`
                }

                if(this.params.product_line_id != undefined && this.params.product_line_id != null && this.params.product_line_id.length != 0){
                    additional_params += '&product_line_id=' + this.params.product_line_id
                    filter_header += ` with Product Line (${this.filterParams.product_line_name})`
                }

                if(this.params.product_type != undefined && this.params.product_type != null && this.params.product_type.length != 0){
                    additional_params += '&product_type=' + this.params.product_type
                    filter_header += ` with Product Type (${this.filterParams.product_type_name})`
                }

                if(this.params.supplier_type_id != undefined && this.params.supplier_type_id != null && this.params.supplier_type_id.length != 0){
                    additional_params += '&supplier_type_id=' + this.params.supplier_type_id
                    filter_header += ` with Supplier Type (${this.filterParams.supplier_type_name})`
                }

                if(this.params.tax_type != undefined && this.params.tax_type != null && this.params.tax_type.length != 0){
                    additional_params += '&tax_type=' + this.params.tax_type
                    filter_header += ` with Tax Type (${this.filterParams.tax_type_name})`
                }

                if(this.params.barcode != undefined && this.params.barcode != null && this.params.barcode != ''){
                    additional_params += '&barcode=' + this.params.barcode
                    filter_header += ` with Barcode (${this.params.barcode})`
                }

                if(this.params.stock_no != undefined && this.params.stock_no != null && this.params.stock_no != ''){
                    additional_params += '&stock_no=' + this.params.stock_no
                    filter_header += ` with Stock No. (${this.params.stock_no})`
                }

                if(this.params.name != undefined && this.params.name != null && this.params.name != ''){
                    additional_params += '&name=' + this.params.name
                    filter_header += ` with Name (${this.params.name})`
                }

                if(this.params.retail_price != undefined && this.params.retail_price != null && this.params.retail_price != ''){
                    additional_params += '&retail_price=' + this.params.retail_price
                    filter_header += ` with Retail Price (${this.params.retail_price})`
                }

                if(this.params.category_id != undefined && this.params.category_id.length != 0){
                    additional_params += '&category_id=' + this.params.category_id
                    if(this.params.category_name != undefined){
                        filter_header += ` with Category (${this.filterParams.category_name})`
                    }
                }

                if(this.params.division_id != undefined && this.params.division_id.length != 0){
                    additional_params += '&division_id=' + this.params.division_id
                    if(this.params.division_name != undefined){
                        filter_header += ` with Division (${this.filterParams.division_name})`
                    }
                }

                if(this.params.department_id != undefined && this.params.department_id.length != 0){
                    additional_params += '&department_id=' + this.params.department_id
                    if(this.params.department_name != undefined){
                        filter_header += ` with Department (${this.filterParams.department_name})`
                    }
                }

                if(this.params.section_id != undefined && this.params.section_id.length != 0){
                    additional_params += '&section_id=' + this.params.section_id
                    if(this.params.section_name != undefined){
                        filter_header += ` with Section (${this.filterParams.section_name})`
                    }
                }

                if(this.params.supplier_id != undefined && this.params.supplier_id.length != 0){
                    additional_params += '&supplier_id=' + this.params.supplier_id
                    filter_header += ` with Supplier (${this.filterParams.supplier_name})`
                }

                if(this.params.brand_id != undefined && this.params.brand_id.length != 0){
                    additional_params += '&brand_id=' + this.params.brand_id
                    filter_header += ` with Brand (${this.filterParams.brand_name})`
                }

                if(this.inputGroupBy == 'hourly'){
                    this.isShowDetail = true
                }

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                if(this.inputTimeFrom == null || this.inputTimeTo == null){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/hourly_sales?site_id=' + this.inputSite + 
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD') + 
                    '&time_from=' + this.inputTimeFrom.format('HH:mm') + '&isShow=' + this.isShowDetail + '&time_to=' + this.inputTimeTo.format('HH:mm') + '&group=' + 
                    this.inputGroupBy + '&display=' + this.inputDisplay + '&terminal=' + this.inputTerminal + additional_params, null);
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
                if(get_request.length > 0){
                    let headers = [];
                    let site_specific = [];
                    if(this.inputDisplay == 'S'){
                        let headers = ['Sale Hours','Sales Amount','Qty Sold','Qty Returned','No of Transaction(s) SALES','No of Transaction(s) RETURN']; //remove dot on header text; causes bug on xls file generation

                        for(let x=0; x < siteSpecific.length; x++){
                            this.birSalesReports = siteSpecific[x].report_details

                            var total_amount_gross = 0
                            var total_quantity = 0
                            var total_return_quantity = 0
                            var total_sales_count = 0
                            var total_return_count = 0

                            let reportData = [];
                            if(this.birSalesReports.length > 0){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]

                                    reportLine.forEach(element => {
                                        let detail = [
                                            `${"'"+element.sale_hours}`,
                                            this.convertToCurrency(Number(element.amount_gross)),
                                            this.convertToCurrency(Number(element.total_quantity)),
                                            this.convertToCurrency(Number(element.return_quantity)),
                                            this.formatNumber(Number(element.sales_count)),
                                            this.formatNumber(Number(element.return_count))
                                        ]

                                        total_amount_gross += Number(element.amount_gross)
                                        total_quantity += Number(element.total_quantity)
                                        total_return_quantity += Number(element.return_quantity)
                                        total_sales_count += Number(element.sales_count)
                                        total_return_count += Number(element.return_count)

                                        reportData.push(Object.assign({}, detail))
                                    });

                                    if(i == this.birSalesReports.length-1){
                                        reportData.push(Object.assign({}, ['Grand Total :', 
                                            this.convertToCurrency(Number(total_amount_gross)),
                                            this.convertToCurrency(Number(total_quantity)),
                                            this.convertToCurrency(Number(total_return_quantity)),
                                            this.formatNumber(Number(total_sales_count)),
                                            this.formatNumber(Number(total_return_count))
                                        ]));
                                    }
                                }
                            }
                            let group_text = ""
                            if(this.inputGroupBy != ''){
                                group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                            }

                            if(this.isSeparateSite == true){
                                reportData.push([siteSpecific[x].report_details[0].site_name]);
                            } else {
                                let site_text = ''
                                let terminal_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = 'Site: ' + siteSpecific[x].report_details[0][0].site_name
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if(s == 0){
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            // site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                            site_text = 'Site: ' + siteSpecific[x].report_details[0][0].site_name
                                        }
                                        terminal_text = 'Terminal: ' + this.terminal_name
                                    }
                                }
                                // reportData.unshift([site_text]);
                                reportData.push([]);
                                reportData.push([site_text]);
                                reportData.push([terminal_text]);
                            }



                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }

                            reportData.push(["Hourly Sales [Net of Returns] Report" + group_text, "Generate By: " + printed_by,"For the Period of " + this.inputDate[0].format('MMMM DD, YYYY')  + " to " + this.inputDate[1].format('MMMM DD, YYYY')])

                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;

                            let newJsonData=[];

                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                                )
                            );
                            newJsonData.push(result)
                            }

                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                                }
                            }
                            });
                            site_specific.push(newJsonData)
                        }
                    } else {
                        let headers = []
                        if(this.inputGroupBy == 'hourly'){
                            headers = ['Product Code','Barcode','Description','Qty Sold','Qty Ret','Amount Sold'];
                        } else {
                            if(this.isShowDetail == false){
                                headers = ['','','','Sales','Return','Qty Sold','Qty Ret', 'Amount Sold'];
                            } else {
                                headers = ['Product Code','Barcode','Description','Sales','Return','Qty Sold','Qty Ret','Amount Sold'];
                            }
                            
                        }
                        
                        for(let x=0; x < siteSpecific.length; x++){
                            this.birSalesReports = siteSpecific[x].report_details

                            var g_total_quantity = 0
                            var g_total_return_quantity = 0
                            var g_total_subtotal = 0

                            let reportData = [];
                            if(this.birSalesReports.length > 0){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]

                                    var h_total_quantity = 0
                                    var h_total_return_quantity = 0
                                    var h_total_subtotal = 0

                                    var s_total_quantity = 0
                                    var s_total_return_quantity = 0
                                    var s_total_subtotal = 0

                                    if(this.inputGroupBy != 'hourly'){
                                        var h_total_sales = 0
                                        var h_total_return = 0

                                        var s_total_sales = 0
                                        var s_total_return = 0
                                    }

                                    let grouper_name = ''
                                    for(var y=0; y < reportLine.length; y++){
                                        var element = reportLine[y];

                                        if(y == 0){
                                            // let detail = [element.sale_hours]
                                            let detail = [`${"'"+element.sale_hours}`]
                                            reportData.push(Object.assign({}, detail))
                                        }

                                        if(element.product_code != ''){
                                            if(this.inputGroupBy == 'hourly'){
                                                let detail = [
                                                    '        ' + element.product_code,
                                                    element.barcode,
                                                    element.product_name,
                                                    this.convertToCurrency(Number(element.quantity)),
                                                    this.convertToCurrency(Number(element.return_quantity)),
                                                    this.convertToCurrency(Number(element.subtotal))
                                                ]

                                                reportData.push(Object.assign({}, detail))
                                            } else {
                                                if (this.isShowDetail == true){
                                                    if(grouper_name == ''){
                                                        let detail_header = [element.grouper_name]
                                                        reportData.push(Object.assign({}, detail_header))
                                                    } else {
                                                        if(grouper_name != element.grouper_name){
                                                            let detail_header = [element.grouper_name];
                                                            reportData.push(Object.assign({}, detail_header))
                                                        }
                                                    }
                                                }

                                                let detail
                                                if(this.isShowDetail == true){
                                                    detail = [
                                                        '        ' + element.product_code,
                                                        element.barcode,
                                                        element.product_name,
                                                        this.formatNumber(Number(element.sales_count)),
                                                        this.formatNumber(Number(element.return_count)),
                                                        this.convertToCurrency(Number(element.quantity)),
                                                        this.convertToCurrency(Number(element.return_quantity)),
                                                        this.convertToCurrency(Number(element.subtotal))
                                                    ]
                                                } else {
                                                    detail = [
                                                        '', '', element.grouper_name,
                                                        this.formatNumber(Number(element.sales_count)),
                                                        this.formatNumber(Number(element.return_count)),
                                                        this.convertToCurrency(Number(element.quantity)),
                                                        this.convertToCurrency(Number(element.return_quantity)),
                                                        this.convertToCurrency(Number(element.subtotal))
                                                    ]
                                                }

                                                reportData.push(Object.assign({}, detail))

                                                grouper_name = element.grouper_name
                                            }
                                        
                                            s_total_quantity += Number(element.quantity)
                                            s_total_return_quantity += Number(element.return_quantity)
                                            s_total_subtotal += Number(element.subtotal)

                                            h_total_quantity += Number(element.quantity)
                                            h_total_return_quantity += Number(element.return_quantity)
                                            h_total_subtotal += Number(element.subtotal)

                                            g_total_quantity += Number(element.quantity)
                                            g_total_return_quantity += Number(element.return_quantity)
                                            g_total_subtotal += Number(element.subtotal)

                                            if(this.inputGroupBy != 'hourly'){
                                                s_total_sales += Number(element.sales_count)
                                                s_total_return += Number(element.return_count)

                                                h_total_sales += Number(element.sales_count)
                                                h_total_return += Number(element.return_count)

                                                if(this.isShowDetail == true){
                                                    if(y == reportLine.length - 1){
                                                        reportData.push(Object.assign({}, [element.grouper_name, '', 'Total :',
                                                            this.formatNumber(Number(s_total_sales)), 
                                                            this.formatNumber(Number(s_total_return)), 
                                                            this.convertToCurrency(Number(s_total_quantity)),
                                                            this.convertToCurrency(Number(s_total_return_quantity)),
                                                            this.convertToCurrency(Number(s_total_subtotal))
                                                        ]));

                                                        s_total_sales = 0
                                                        s_total_return = 0
                                                        s_total_quantity = 0
                                                        s_total_return_quantity = 0
                                                        s_total_subtotal = 0
                                                    } else {
                                                        let current_grouper = element.grouper_name
                                                        let next_grouper = reportLine[y+1].grouper_name

                                                        if(current_grouper != next_grouper){
                                                            reportData.push(Object.assign({}, [element.grouper_name, '', 'Total :',
                                                                this.formatNumber(Number(s_total_sales)), 
                                                                this.formatNumber(Number(s_total_return)), 
                                                                this.convertToCurrency(Number(s_total_quantity)),
                                                                this.convertToCurrency(Number(s_total_return_quantity)),
                                                                this.convertToCurrency(Number(s_total_subtotal))
                                                            ]));

                                                            s_total_sales = 0
                                                            s_total_return = 0
                                                            s_total_quantity = 0
                                                            s_total_return_quantity = 0
                                                            s_total_subtotal = 0
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if(this.inputGroupBy == 'hourly'){
                                        reportData.push(Object.assign({}, ['', '', 'Hourly Total :',
                                            this.convertToCurrency(Number(h_total_quantity)),
                                            this.convertToCurrency(Number(h_total_return_quantity)),
                                            this.convertToCurrency(Number(h_total_subtotal))
                                        ]));
                                    } else {
                                        reportData.push(Object.assign({}, ['', '', 'Hourly Total :',
                                            this.formatNumber(Number(h_total_sales)), 
                                            this.formatNumber(Number(h_total_return)), 
                                            this.convertToCurrency(Number(h_total_quantity)),
                                            this.convertToCurrency(Number(h_total_return_quantity)),
                                            this.convertToCurrency(Number(h_total_subtotal))
                                        ]));
                                    }

                                    if(i == this.birSalesReports.length-1){
                                        if(this.inputGroupBy == 'hourly'){
                                            reportData.push(Object.assign({}, ['', '', 'Grand Total', 
                                                this.convertToCurrency(Number(g_total_quantity)),
                                                this.convertToCurrency(Number(g_total_return_quantity)),
                                                this.convertToCurrency(Number(g_total_subtotal))
                                            ]))    
                                        } else {
                                            reportData.push(Object.assign({}, ['', '', 'Grand Total', ' - ', ' - ',
                                                this.convertToCurrency(Number(g_total_quantity)),
                                                this.convertToCurrency(Number(g_total_return_quantity)),
                                                this.convertToCurrency(Number(g_total_subtotal))
                                            ]))
                                        }
                                    }
                                }
                            }
                             if(this.isSeparateSite == true){
                                reportData.push([siteSpecific[x].report_details[0].site_name]);
                            } else {
                                let site_text = ''
                                let terminal_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = 'Site: ' + siteSpecific[x].report_details[0][0].site_name
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if(s == 0){
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            // site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                            site_text = 'Site: ' + siteSpecific[x].report_details[0][0].site_name
                                        }
                                        terminal_text = 'Terminal: ' + this.terminal_name
                                    }
                                }
                                // reportData.unshift([site_text]);
                                reportData.push([]);
                                reportData.push([site_text]);
                                reportData.push([terminal_text]);
                            }
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
                            reportData.push([])
                            if(this.inputGroupBy == 'hourly'){
                                reportData.push(["Hourly Sales [Net of Returns] Report by Item", "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            } else if (this.inputGroupBy == 'category_id') {
                                reportData.push(["Hourly Sales [Net of Returns] Report by Category", "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            } else if (this.inputGroupBy == 'division_id') {
                                reportData.push(["Hourly Sales [Net of Returns] Report by Division", "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            } else if (this.inputGroupBy == 'department_id') {
                                reportData.push(["Hourly Sales [Net of Returns] Report by Department", "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            } else if (this.inputGroupBy == 'section_id') {
                                reportData.push(["Hourly Sales [Net of Returns] Report by Section", "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            } else if (this.inputGroupBy == 'supplier_id') {
                                reportData.push(["Hourly Sales [Net of Returns] Report by Supplier", "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            }
                            reportData.push([])

                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;

                            let newJsonData=[];

                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                                )
                            );
                            newJsonData.push(result)
                            }

                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                                }
                            }
                            });
                            site_specific.push(newJsonData)
                        }
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>